import { useColorModeValue } from '@chakra-ui/react';

export const useRunProgressColors = () => {
  const textColor = useColorModeValue('gray.700', 'white');
  const backgroundCardColor = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const secondaryTextColor = useColorModeValue('gray.500', 'gray.400');
  const accentColor = useColorModeValue('teal.500', 'teal.300');

  return {
    textColor,
    backgroundCardColor,
    borderColor,
    secondaryTextColor,
    accentColor,
  };
};
